import { styled, Grid as MuiGrid } from "@mui/material";
import { getThemeSpacing } from "../../../functions/util";

import {
  baliHai,
  solitude,
  white,
  matisse,
  crusta,
  supernova
} from "../../../assets/styles/colors";

const PREFIX = "InsertionPanelStyles";
export const classes = {
  chip: `${PREFIX}-chip`,
  whiteChip: `${PREFIX}-whiteChip`,
  redLabelChip: `${PREFIX}-redLabelChip`,
  orangeChip: `${PREFIX}-orangeChip`,
  iconButton: `${PREFIX}-iconButton`,
  typographyInsertionHeader: `${PREFIX}-typographyInsertionHeader`,
  typographyInvoicedInsertionHeader: `${PREFIX}-typographyInvoicedInsertionHeader`,
  ctcProperty: `${PREFIX}-ctcProperty`,
  ctcTooltip: `${PREFIX}-ctcTooltip`
};

export const Grid = styled(MuiGrid)(({ theme }) => ({
  [`& .${classes.chip}`]: {
    color: baliHai,
    marginLeft: theme.typography.pxToRem(getThemeSpacing(theme, 1)),
    minWidth: theme.typography.pxToRem(80),
    backgroundColor: solitude,
    padding: theme.typography.pxToRem(10)
  },
  [`& .${classes.whiteChip}`]: {
    backgroundColor: white
  },
  [`& .${classes.redLabelChip}`]: {
    color: crusta
  },
  [`& .${classes.orangeChip}`]: {
    backgroundColor: supernova,
    fontWeight: "bold"
  },
  [`& .${classes.iconButton}`]: {
    width: theme.typography.pxToRem(32),
    height: theme.typography.pxToRem(32),
    marginRight: theme.typography.pxToRem(getThemeSpacing(theme, 1))
  },
  [`& .${classes.typographyInsertionHeader}`]: {
    color: matisse,
    width: theme.typography.pxToRem(195),
    fontSize: theme.typography.pxToRem(12),
    marginLeft: theme.typography.pxToRem(getThemeSpacing(theme, 1)),
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  [`& .${classes.typographyInvoicedInsertionHeader}`]: {
    color: crusta
  },
  [`& .${classes.ctcProperty}`]: {
    color: theme.palette.common.white,
    display: "inline-block"
  },
  [`& .${classes.ctcTooltip}`]: {
    width: "110px"
  }
}));
